import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Footer() {
  const { t } = useLanguage()
  const currentYear = 2026

  const footerLinks = [
    { id: 'footer_about', label: t('footer.about'), href: '/homepage#about' },
    { id: 'footer_catalog', label: t('footer.catalog'), href: '/homepage#catalog' },
    { id: 'footer_quality', label: t('footer.quality'), href: '/homepage#quality' },
    { id: 'footer_logistics', label: t('footer.logistics'), href: '/homepage#logistics' },
    { id: 'footer_values', label: t('footer.values'), href: '/homepage#values' },
    { id: 'footer_certifications', label: t('footer.certifications'), href: '/homepage#certifications' },
  ]

  return (
    <footer className="bg-muted border-t border-border py-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex flex-col items-center md:items-start gap-1">
            <Link
              href="/homepage"
              className="font-serif text-xl font-semibold text-foreground"
            >
              AUTOFIT CANADA LTD
            </Link>
            <span className="text-xs text-muted-foreground">Canada · Seafood Import &amp; Distribution</span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2">
            {footerLinks?.map((link, index) => (
              <span key={link?.id} className="flex items-center gap-8">
                <a
                  href={link?.href}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {link?.label}
                </a>
                {index < footerLinks?.length - 1 && (
                  <span className="hidden md:inline text-muted-foreground">
                    ·
                  </span>
                )}
              </span>
            ))}
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <a
              href="https://wa.me/14506011665"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-colors"
              aria-label="Contact via WhatsApp"
            >
              <Icon name="ChatBubbleLeftRightIcon" size={20} />
            </a>
            <a
              href="mailto:info@autofitcanada.com"
              className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-colors"
              aria-label="Contact via Email"
            >
              <Icon name="EnvelopeIcon" size={20} />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-6 border-t border-border text-center">
          <p className="text-sm text-muted-foreground">
            © {currentYear} {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}